/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetOrders200ResponseOrdersInner } from './GetOrders200ResponseOrdersInner';
import {
    GetOrders200ResponseOrdersInnerFromJSON,
    GetOrders200ResponseOrdersInnerFromJSONTyped,
    GetOrders200ResponseOrdersInnerToJSON,
    GetOrders200ResponseOrdersInnerToJSONTyped,
} from './GetOrders200ResponseOrdersInner';

/**
 * 
 * @export
 * @interface GetOrders200Response
 */
export interface GetOrders200Response {
    /**
     * 
     * @type {number}
     * @memberof GetOrders200Response
     */
    total: number;
    /**
     * 
     * @type {Array<GetOrders200ResponseOrdersInner>}
     * @memberof GetOrders200Response
     */
    orders: Array<GetOrders200ResponseOrdersInner>;
}

/**
 * Check if a given object implements the GetOrders200Response interface.
 */
export function instanceOfGetOrders200Response(value: object): value is GetOrders200Response {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('orders' in value) || value['orders'] === undefined) return false;
    return true;
}

export function GetOrders200ResponseFromJSON(json: any): GetOrders200Response {
    return GetOrders200ResponseFromJSONTyped(json, false);
}

export function GetOrders200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrders200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'orders': ((json['orders'] as Array<any>).map(GetOrders200ResponseOrdersInnerFromJSON)),
    };
}

export function GetOrders200ResponseToJSON(json: any): GetOrders200Response {
    return GetOrders200ResponseToJSONTyped(json, false);
}

export function GetOrders200ResponseToJSONTyped(value?: GetOrders200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'orders': ((value['orders'] as Array<any>).map(GetOrders200ResponseOrdersInnerToJSON)),
    };
}

